import { render, staticRenderFns } from "./CheckboxGroup.vue?vue&type=template&id=4bdf94e8&scoped=true"
import script from "./CheckboxGroup.vue?vue&type=script&lang=js"
export * from "./CheckboxGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdf94e8",
  null
  
)

export default component.exports